const ICON_EXPAND = ({ width, height, fill, stroke }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 10}
      height={height || 10}
      viewBox="0 0 3.925 3.925"
      className="margin_left"
    >
      <path
        d="m443.56 84.139 1.323 1.323 1.323-1.323z"
        style={{
          fillRule: "evenodd",
          fill: fill || "#000",
          paintOrder: "stroke markers fill",
          stroke: stroke || "#000",
        }}
        transform="translate(-442.92 -82.838)"
      />
    </svg>
  );
};

export default ICON_EXPAND;
